import { AddCircleOutline } from "@mui/icons-material";
import { Box } from "@mui/material";
import Input from "../../../../components/input/Input-v2";
import { ModalFC } from "../../../../components/modal/Modal";
import { useEffect, useState } from "react";
import { LoadingButton } from "../../../../components/button/Button";
import useGenerateOptions from "../../../../components/input/hook/useGenerateOptions2";
import {
  useAddCategory,
  useGetCategory,
  useGetCategoryDetail,
} from "../../api/product/category/resolver";
import { useWatch } from "react-hook-form";

interface InputCategory {
  control: any;
  controlName: string;
  disabled?: boolean;
}

export default function InputCategory({
  control,
  controlName,
  disabled,
}: InputCategory) {
  const [keyword, setKeyword] = useState<string>();
  const [idDetailCategory, setIdDetailCategory] = useState();
  const { data: dataRawDetailCategory, isLoading: loadingDetailCategory } =
    useGetCategoryDetail({
      product_category_id: idDetailCategory,
    });
  const dataDetailCategory = dataRawDetailCategory?.data.data;
  const { mutate, isLoading } = useAddCategory();
  const { data: dataRaw, isLoading: isFetching } = useGetCategory({
    page: 1,
    keyword,
  });
  const dataCategory = dataRaw?.data.data.data;
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const { data: dataOptionCategory } = useGenerateOptions({
    keyForText: "category_name",
    keyForValue: "id",
    dataSource: dataCategory,
  });
  const idCategory = useWatch({
    control,
    name: controlName,
  });

  useEffect(() => {
    if (idCategory) {
      setIdDetailCategory(idCategory);
    }
  }, [idCategory]);

  useEffect(() => {
    if (dataDetailCategory) {
      setKeyword(dataDetailCategory.category_name);
    }
  }, [dataDetailCategory]);

  const handleAdd = () => {
    mutate({
      category_name: name,
    });
  };

  return (
    <Box display={"flex"} gap={1} height={"100%"}>
      <Box flexBasis={"90%"}>
        <Input.Controller
          control={control}
          name={controlName}
          rules={{ required: "Kolom ini tidak boleh kosong" }}
          render={(field, fieldState) => (
            <Input.Autocomplete
              disable={disabled}
              isFetching={isFetching}
              label="Kategori"
              options={dataOptionCategory}
              onChange={(e) => setKeyword(e)}
              onClick={(e) => field.onChange(e.value)}
              value={field.value}
              error={fieldState.error?.message}
            />
          )}
        />
      </Box>
      {!disabled && (
        <Box
          display={"flex"}
          height={"100%"}
          alignItems={"flex-end"}
          onClick={() => setShowModal(true)}
        >
          <AddCircleOutline
            style={{ cursor: "pointer" }}
            color={"primary"}
            fontSize={"large"}
          />
        </Box>
      )}
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Input.Text
          label="Nama Kategori"
          value={name}
          onChange={(e) => setName(e)}
        />
        <Box display={"flex"} justifyContent={"flex-end"} mt={1}>
          <LoadingButton
            text="Tambah"
            isLoading={isLoading}
            onClick={handleAdd}
          />
        </Box>
      </ModalFC>
    </Box>
  );
}
